import CardLauncher from "@/components/Common/CardLauncher";
import { Card } from "@/components/ui/card";
import { useState } from "react";
import APISection from "../components/Documentation/DocumentationAPISection";
import DataSection from "../components/Documentation/DocumentationDataSection";
import ContinuousSection from "../components/Documentation/DocumentationContinuousSection";
import Boolean from "../components/Documentation/DocumentationBooleanSection";
import ResultsSection from "../components/Documentation/DocumentationResultsSection";

export default function DocumentationContainer() {
  const [selectedSection, setSelectedSection] = useState(
    "Boolean Operations Guide",
  );

  const renderSection = () => {
    switch (selectedSection) {
      case "API Navigation":
        return <APISection />;
      case "Data Confidentiality":
        return <DataSection />;
      case "Continuous Monitoring":
        return <ContinuousSection />;
      case "Boolean Operations Guide":
        return <Boolean />;
      case "Results Guide":
        return <ResultsSection />;
    }
  };
  return (
    <div className="h-screen p-3 pr-0 pb-3">
      {/* Outer container handles scrolling */}
      <div
        className="scrollbar-thin relative h-full overflow-y-auto"
        style={{
          transform: "translateZ(0)",
          scrollBehavior: "auto",
          overscrollBehavior: "contain",
        }}
      >
        <div className="flex gap-4">
          {/* Sidebar */}
          <div className="sticky top-0 h-fit w-[300px] flex-shrink-0 px-3">
            <CardLauncher
              showLaunchButton={false}
              contents={true}
              onSectionSelect={setSelectedSection}
            />
          </div>

          {/* Main content */}
          <div className="flex flex-1 justify-center md:ml-0 xl:-ml-[200px] 2xl:-ml-[300px]">
            <Card className="h-auto w-[680px] bg-white pr-2">
              <div className="flex flex-col space-y-5 px-[32px] pt-5 pb-1">
                <h1 className="pt-5 text-xl leading-[36px] font-bold -tracking-wide">
                  Documentation
                </h1>
                {/* Animated section content */}
                <div
                  key={selectedSection}
                  className="animate-in fade-in slide-in-from-right-4 duration-700 ease-in-out"
                  style={{
                    animationFillMode: "both",
                  }}
                >
                  {renderSection()}
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
